import { render, staticRenderFns } from "./VirtualDeviceTableView.vue?vue&type=template&id=2dacbff6&scoped=true&"
import script from "./VirtualDeviceTableView.vue?vue&type=script&lang=js&"
export * from "./VirtualDeviceTableView.vue?vue&type=script&lang=js&"
import style0 from "./VirtualDeviceTableView.vue?vue&type=style&index=0&id=2dacbff6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dacbff6",
  null
  
)

export default component.exports